export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 mx-4 md:mx-6 my-4 md:my-5 rounded-2xl md:rounded-3xl overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20arrangement%20of%20curated%20fashion%20pieces%20including%20textured%20knitwear%20premium%20leather%20sneakers%20and%20minimalist%20accessories%20draped%20across%20warm%20beige%20linen%20fabric%20with%20dried%20botanical%20sprigs%20and%20organic%20eucalyptus%20accents%20soft%20diffused%20morning%20light%20creating%20gentle%20abstract%20shadow%20play%20editorial%20lifestyle%20photography%20harmonious%20earth%20toned%20palette%20clean%20negative%20space%20composition&width=1600&height=900&seq=hero-main-v2-x98a&orientation=landscape"
          alt="Pandabuy Spreadsheet product collection flatlay"
          title="Best Pandabuy Spreadsheet 2026 – Updated Finds Collection"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full flex flex-col items-center text-center px-4 md:px-8">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/25 bg-white/10 backdrop-blur-sm mb-6">
          <span className="w-2 h-2 rounded-full bg-green-400"></span>
          <span className="text-xs md:text-sm font-medium text-white tracking-wide">Updated Daily</span>
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight max-w-4xl">
          Best Pandabuy Spreadsheet
          <br />
          <span className="font-light italic">2026</span>
        </h1>

        <p className="mt-5 md:mt-6 text-sm md:text-base text-white/80 max-w-xl leading-relaxed">
          Discover the latest Pandabuy Spreadsheet collections, trusted sellers, fashion finds, and buying guides. Updated daily with sneakers, clothing, accessories, and budget finds.
        </p>

        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-7 py-3 text-sm md:text-base font-semibold rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            Browse Spreadsheet
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-sm"></i>
            </span>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-7 py-3 text-sm md:text-base font-medium rounded-full border border-white/60 text-white hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            View Latest Finds
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <span className="w-8 h-12 flex items-center justify-center">
          <i className="ri-mouse-line text-white/40 text-xl animate-bounce"></i>
        </span>
      </div>
    </section>
  );
}